import { B2BColorConfig, defaultB2BColors } from "redmond";
export const colors: B2BColorConfig = defaultB2BColors;
